/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HostNameAndXmlLinkData
 */
export interface HostNameAndXmlLinkData {
    /**
     * 
     * @type {string}
     * @memberof HostNameAndXmlLinkData
     */
    hostName?: string;
    /**
     * 
     * @type {string}
     * @memberof HostNameAndXmlLinkData
     */
    xmlLink?: string;
}

/**
 * Check if a given object implements the HostNameAndXmlLinkData interface.
 */
export function instanceOfHostNameAndXmlLinkData(value: object): value is HostNameAndXmlLinkData {
    return true;
}

export function HostNameAndXmlLinkDataFromJSON(json: any): HostNameAndXmlLinkData {
    return HostNameAndXmlLinkDataFromJSONTyped(json, false);
}

export function HostNameAndXmlLinkDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostNameAndXmlLinkData {
    if (json == null) {
        return json;
    }
    return {
        
        'hostName': json['hostName'] == null ? undefined : json['hostName'],
        'xmlLink': json['xmlLink'] == null ? undefined : json['xmlLink'],
    };
}

export function HostNameAndXmlLinkDataToJSON(json: any): HostNameAndXmlLinkData {
    return HostNameAndXmlLinkDataToJSONTyped(json, false);
}

export function HostNameAndXmlLinkDataToJSONTyped(value?: HostNameAndXmlLinkData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostName': value['hostName'],
        'xmlLink': value['xmlLink'],
    };
}

